/* global axios */
import ApiClient from '../ApiClient';

class NexceoUnitInventoryAPI extends ApiClient {
  constructor() {
    super('nexceo/projects', { accountScoped: true });
  }

  list(projectId, params = {}) {
    return axios.get(`${this.url}/${projectId}/inventory`, { params });
  }

  show(projectId, unitId) {
    return axios.get(`${this.url}/${projectId}/inventory/${unitId}`);
  }

  create(projectId, payload) {
    return axios.post(`${this.url}/${projectId}/inventory`, {
      unit_inventory: payload,
    });
  }

  update(projectId, unitId, payload) {
    return axios.patch(`${this.url}/${projectId}/inventory/${unitId}`, {
      unit_inventory: payload,
    });
  }

  destroy(projectId, unitId) {
    return axios.delete(`${this.url}/${projectId}/inventory/${unitId}`);
  }

  markAvailable(projectId, unitId) {
    return axios.post(
      `${this.url}/${projectId}/inventory/${unitId}/mark_available`
    );
  }

  markHold(projectId, unitId) {
    return axios.post(`${this.url}/${projectId}/inventory/${unitId}/mark_hold`);
  }

  markBlocked(projectId, unitId) {
    return axios.post(
      `${this.url}/${projectId}/inventory/${unitId}/mark_blocked`
    );
  }

  markSold(projectId, unitId) {
    return axios.post(`${this.url}/${projectId}/inventory/${unitId}/mark_sold`);
  }

  markLandowner(projectId, unitId) {
    return axios.post(
      `${this.url}/${projectId}/inventory/${unitId}/mark_landowner`
    );
  }

  // marker: { x, y, width, height } as percentages (0-100) of the floor
  // plan image — see Nexceo::UnitInventory#marker.
  markPosition(projectId, unitId, marker) {
    return axios.post(
      `${this.url}/${projectId}/inventory/${unitId}/mark_position`,
      { marker }
    );
  }

  uploadFloorPlanImage(projectId, unitId, file) {
    const formData = new FormData();
    formData.append('image', file);
    return axios.post(
      `${this.url}/${projectId}/inventory/${unitId}/upload_floor_plan_image`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }
}

export default new NexceoUnitInventoryAPI();
